module.exports = __webpack_public_path__ + "img/shape.28dca245.svg";